import { apiClient, unwrap } from './client';

export interface HoldingFilialeRow {
  id:             string;
  filialeKey:     string;
  name:           string;
  fullName:       string;
  pays:           string;
  devise:         string;
  metier:         string;
  metierLabel:    string;
  isActive:       boolean;
  /** Lot 1, étape 1.3 : active ou dormante (pas encore lancée). */
  statut:         'active' | 'dormante';
  colorPrimary:   string;
  colorSecondary: string;
  colorAccent:    string;
  logoPath:       string;
  stats:          { usersCount: number; hasBusinessData: boolean };
}

export interface HoldingUserRow {
  id:           string;
  email:        string;
  fullName:     string;
  role:         string;
  phone:        string | null;
  filialeId:    string;
  filialeCode:  string;
  filialeName:  string | null;
  isActive:     boolean;
  lastLoginAt:  string | null;
  createdAt:    string;
}

export interface UpdateHoldingUserPayload {
  role?:     string;
  fullName?: string;
  phone?:    string | null;
  isActive?: boolean;
}

export const holdingUsersApi = {
  listFiliales: async (): Promise<HoldingFilialeRow[]> => {
    const res = await apiClient.get('/holding/filiales');
    return unwrap<HoldingFilialeRow[]>(res);
  },

  list: async (filiale?: string): Promise<HoldingUserRow[]> => {
    const res = await apiClient.get('/holding/users', { params: filiale ? { filiale } : undefined });
    return unwrap<HoldingUserRow[]>(res);
  },

  update: async (userId: string, filiale: string, payload: UpdateHoldingUserPayload): Promise<HoldingUserRow> => {
    const res = await apiClient.patch(`/holding/users/${userId}`, payload, { params: { filiale } });
    return unwrap<HoldingUserRow>(res);
  },

  remove: async (userId: string, filiale: string): Promise<{ deleted: true; email: string }> => {
    const res = await apiClient.delete(`/holding/users/${userId}`, { params: { filiale } });
    return unwrap<{ deleted: true; email: string }>(res);
  },

  resetPassword: async (userId: string, filiale: string): Promise<{ email: string; actionLink: string | null; sent: boolean }> => {
    const res = await apiClient.post(`/holding/users/${userId}/reset-password`, null, { params: { filiale } });
    return unwrap<{ email: string; actionLink: string | null; sent: boolean }>(res);
  },
};
